<template>
    <div v-if="!utils.CheckIfNullOrEmpty(local_filter)">
        <div class="rounded-4">
            <div class="row align-items-start m-0 gap-2">
                <div class="p-0 mt-2" style="width: 24%">
                    <label class="mb-2">{{ $t("res_Label_Subject") }}</label>
                    <v-text-field v-model="local_filter.subject" type="text" class="search-field light-bg"
                        :placeholder="$t('res_Placeholder_EnterSubject')"></v-text-field>
                </div>
                <div class="p-0 mt-2" style="width: 24%">
                    <label class="mb-2">{{ $t("res_MenuItems_ReferenceNumber") }}</label>
                    <v-text-field v-model="local_filter.referenceNumber" type="text" class="search-field light-bg"
                        :placeholder="$t('res_Placeholder_EnterReference')"></v-text-field>
                </div>
                <div class="p-0 mt-2" style="width: 24%">
                    <label class="mb-2">{{ $t("res_Label_FromDate") }}</label>
                    <v-menu offset-y content-class="p-0" v-model="from_date_datePicker" :close-on-content-click="false">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field :value="utils.dateFormat(local_filter.fromDate)" class="bg-white" label=""
                                readonly v-bind="attrs" v-on="on" solo append-icon="mdi-calendar"
                                :placeholder="constants.defaultDateValue">
                                <template v-slot:append>
                                    <v-icon v-bind="attrs" v-on="on">mdi-calendar</v-icon>
                                </template>
                            </v-text-field>
                        </template>
                        <v-date-picker id="advanced-date-menu" v-model="local_filter.fromDate" :max="new Date().toISOString().slice(0, 10)"
                            @input="from_date_datePicker = false" @change="validateDate('from')"></v-date-picker>
                    </v-menu>
                </div>
                <div class="p-0 mt-2" style="width: 24%">
                    <label class="mb-2">{{ $t("res_Label_ToDate") }}</label>
                    <v-menu content-class="p-0" offset-y v-model="to_date_datePicker" :close-on-content-click="false">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field :value="utils.dateFormat(local_filter.toDate)" label="" readonly v-bind="attrs"
                                v-on="on" solo append-icon="mdi-calendar" :placeholder="constants.defaultDateValue">
                                <template v-slot:append>
                                    <v-icon v-bind="attrs" v-on="on">mdi-calendar</v-icon>
                                </template>
                            </v-text-field>
                        </template>
                        <v-date-picker id="advanced-date-menu" v-model="local_filter.toDate" :max="new Date().toISOString().slice(0, 10)"
                            @input="to_date_datePicker = false" @change="validateDate('to')"></v-date-picker>
                    </v-menu>
                </div>
                <div class="p-0 mt-2" style="width: 24%">
                    <label class="mb-2">{{ $t("res_GridHeaders_FromStructure") }}</label>
                    <StructureUserSelector class="w-100" :showInternalUsers="false" :showExternalUsers="false"
                        :showInternalStructures="true" :showExternalStructures="true" :excludeSelf="false"
                        :isMultiple="false" :selectedStructureUser="local_filter.fromStructure"
                        @structureUserSelectChanged="setStructure($event, 1)" addressBook_header="Select Structure">
                    </StructureUserSelector>
                </div>
                <div class="p-0 mt-2" style="width: 24%">
                    <label class="mb-2">{{ $t("res_GridHeaders_ToStructure") }}</label>
                    <StructureUserSelector class="w-100" :showInternalUsers="false" :showExternalUsers="false"
                        :showInternalStructures="true" :showExternalStructures="true" :excludeSelf="false"
                        :isMultiple="false" :selectedStructureUser="local_filter.toStructure"
                        @structureUserSelectChanged="setStructure($event, 2)" addressBook_header="Select Structure">
                    </StructureUserSelector>
                </div>
                <div class="p-0 mt-2" style="width: 24%">
                    <label class="mb-2">{{ $t("res_GridHeaders_FromUser") }}</label>
                    <StructureUserSelector class="w-100" :showInternalUsers="true" :showExternalUsers="false"
                        :showInternalStructures="false" :showExternalStructures="false" :excludeSelf="false"
                        :isMultiple="false" :selectedStructureUser="local_filter.fromUser"
                        @structureUserSelectChanged="setUser($event, 1)" addressBook_header="Select User">
                    </StructureUserSelector>
                </div>
                <div class="p-0 mt-2" style="width: 24%">
                    <label class="mb-2">{{ $t("res_GridHeaders_ToUser") }}</label>
                    <StructureUserSelector class="w-100" :showInternalUsers="true" :showExternalUsers="false"
                        :showInternalStructures="true" :showExternalStructures="false" :excludeSelf="false"
                        :isMultiple="false" :selectedStructureUser="local_filter.toUser"
                        @structureUserSelectChanged="setUser($event, 2)" addressBook_header="Select User">
                    </StructureUserSelector>
                </div>
                <div class="p-0 mt-2" style="width: 24%">
                    <label class="mb-2">{{ $t("res_Label_Priority") }}</label>
                    <multiselect class="light-bg add-arrow mt-1" v-model="local_filter.priorityLevel" label="name"
                        track-by="id" open-direction="bottom" :options="priorities" :searchable="true" :loading="false"
                        :internal-search="false" :clear-on-select="false" :close-on-select="true" :options-limit="300"
                        :max-height="600" :show-no-results="false" :hide-selected="false" :multiple="false" ref="multiselect1"
                        :placeholder="$t('res_Label_Priority')">
                    </multiselect>
                </div>
                <div class="p-0 mt-2" style="width: 24%">
                    <label class="mb-2">{{ $t("res_Label_Privacy") }}</label>
                    <multiselect class="light-bg add-arrow mt-1" v-model="local_filter.privacyLevel" label="name"
                        track-by="id" open-direction="bottom" :options="privacies" :searchable="true" :loading="false"
                        :internal-search="false" :clear-on-select="false" :close-on-select="true" :options-limit="300"
                        :max-height="600" :show-no-results="false" :hide-selected="false" :multiple="false" ref="multiselect2"
                        :placeholder="$t('res_Label_Privacy')">
                    </multiselect>
                </div>
                
                <div class="p-0 mt-2" style="width: 24%">
                    <label class="mb-2">{{ $t("res_Label_Category") }}</label>
                    <multiselect class="light-bg add-arrow" v-model="local_filter.category" label="name"  track-by="id"
                            open-direction="bottom" :options="categories" :searchable="false" :internal-search="false"
                            :clear-on-select="false" :close-on-select="true" :options-limit="300" :max-height="600"
                            :show-no-results="false" :hide-selected="false" :multiple="false" ref="multiselect3"
                            :placeholder="$t('res_Label_Category')">
                    </multiselect>
                </div>
                <div class="p-0 mt-2" style="width: 24%">
                    <label class="mb-2">{{ $t("res_Label_Status") }}</label>
                    <multiselect class="light-bg add-arrow" v-model="local_filter.status" label="name"  track-by="id"
                            open-direction="bottom" :options="statuses" :searchable="false" :internal-search="false"
                            :clear-on-select="false" :close-on-select="true" :options-limit="300" :max-height="600"
                            :show-no-results="false" :hide-selected="false" :multiple="false" ref="multiselect4" :placeholder="$t('res_Label_Status')">
                    </multiselect>
                </div>
                <div class="p-0 mt-2" style="width: 24%" v-if="constants.showContentSearchInAdvancedSearch">
                    <label class="mb-2">{{ $t("res_Label_Content") }}</label>
                    <v-text-field v-model="local_filter.content" type="text" class="search-field w-100 light-bg"
                        :placeholder="$t('res_Label_Content')"></v-text-field>
                </div>
                <div class="p-0 mt-2" style="width: 24%">
                    <label class="mb-2">{{ $t("res_Label_Tags") }}</label>
                    <v-text-field v-model="local_filter.tags" type="text" class="search-field w-100 light-bg"
                        :placeholder="$t('res_Label_Tags')"></v-text-field>
                </div>
                <div class="p-0 mt-2" style="width: 24%">
                    <label class="mb-2">{{ $t("res_Label_Links") }}</label>
                    <v-text-field v-model="local_filter.links" type="text" class="search-field w-100 light-bg"
                        :placeholder="$t('res_Label_Links')"></v-text-field>
                </div>
                <div class="p-0 mt-2" style="width: 24%">
                    <label class="mb-2">{{ $t("res_Label_ReceivedDate") }}</label>
                    <v-menu content-class="p-0" offset-y v-model="received_date_datePicker" :close-on-content-click="false">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field :value="utils.dateFormat(local_filter.receivedDate)" label="" readonly v-bind="attrs"
                                v-on="on" solo append-icon="mdi-calendar" :placeholder="constants.defaultDateValue">
                                <template v-slot:append>
                                    <v-icon v-bind="attrs" v-on="on">mdi-calendar</v-icon>
                                </template>
                            </v-text-field>
                        </template>
                        <v-date-picker id="advanced-date-menu" v-model="local_filter.receivedDate" :max="new Date().toISOString().slice(0, 10)"
                            @input="received_date_datePicker = false" @change="validateDate('to')"></v-date-picker>
                    </v-menu>
                </div>
                <div class="p-0 mt-2" style="width: 24%">
                    <label class="mb-2">{{ $t("res_Label_Template") }}</label>
                    <multiselect class="light-bg add-arrow" v-model="local_filter.template" label="name"  track-by="id"
                            open-direction="bottom" :options="templates" :searchable="false" :internal-search="false"
                            :clear-on-select="false" :close-on-select="true" :options-limit="300" :max-height="600"
                            :show-no-results="false" :hide-selected="false" :multiple="false" ref="multiselect5"  
                            :placeholder="$t('res_Label_Template')">
                    </multiselect>
                </div>

                <div class="p-0 mt-2" style="width: 24%">
                    <label class="mb-2">{{ $t("res_Label_Purpose") }}</label>
                    <multiselect class="light-bg add-arrow" v-model="local_filter.purpose" label="name"  track-by="id"
                            open-direction="bottom" :options="purposes" :searchable="false" :internal-search="false"
                            :clear-on-select="false" :close-on-select="true" :options-limit="300" :max-height="600"
                            :show-no-results="false" :hide-selected="false" :multiple="false" ref="multiselect6" :placeholder="$t('res_Label_Purpose')">
                    </multiselect>
                </div>

                <div class="d-flex" style="width: 24%">
                    <div class="p-0 mt-2 ml-4 mr-4">
                        <label class="mb-2">{{ $t("res_ButtonText_SignedByMe") }}</label>
                        <v-checkbox v-model="local_filter.SignedByMe" color="#00ae8d" style="margin-top: 10px"></v-checkbox>
                    </div>
                    <div class="p-0 mt-2 ml-4 mr-4">
                        <label class="mb-2">{{ $t("res_ButtonText_ArchiverByMe") }}</label>
                        <v-checkbox v-model="local_filter.ArchivedByMe" color="#00ae8d" style="margin-top: 10px"></v-checkbox>
                    </div>
                    <div class="p-0 mt-2 ml-4 mr-4">
                        <label class="mb-2">{{ $t("res_ButtonText_RejectedByMe") }}</label>
                        <v-checkbox v-model="local_filter.RejectedByMe" color="#00ae8d" style="margin-top: 10px"></v-checkbox>
                    </div>
                </div>
            </div>
            <div class="d-flex mt-4">
                <div class="mr-auto" v-if="constants.showMoreFiltersInAdvancedSearch">
                    <div class="">
                        <span v-if="!utils.CheckIfNullOrEmpty(dynamicFormFilter_byStructureDictionary) || !utils.CheckIfNullOrEmpty(dynamicFormFilter_byTemplateDictionary)" class="red-dot"></span>
                        <v-btn dense @click="openDynamicFormsFilterDialog()" class="light-blue">
                            {{ $t("res_Label_MoreFilters") }}
                        </v-btn>
                    </div>
                </div>
                <v-btn dense @click="clearFilters()" class="light-blue mr-2">{{ $t("res_Label_ClearAll") }}</v-btn>
                <v-btn dense @click="applyFilters()" class="primary mr-2">{{ $t("res_ButtonText_Search") }}</v-btn>
            </div>
            <v-dialog v-model="showDynamicFormsFilterDialog" content-class="dialog2 address-book-dialog with-fixed-actions">
                <div class="dialog-header" style="z-index: 3000 !important;">
                    <h1>{{ $t('res_Label_MoreFilters') }}</h1>
                </div>
                <div class="dialog-body white-container p-4">
                    <DynamicFormRender :ref="'formStructureAndCategory'" :formId="'dynamicFormByStructureIdAndCategoryId' + dynamicFormRandomRef"
                        :filters="filterByStructureIdAndCategoryId"></DynamicFormRender>
                    <div v-for="(item, index) in templateRenderObjects">
                        <DynamicFormRender :ref="'dynamicForm_' + index" :formId="item.dynamicFormByTemplateId +''+ dynamicFormRandomRef"
                            :filters="item.filterByTemplateId"></DynamicFormRender>
                    </div>
                </div>
                <v-card-actions class="gap-2 sticky-actions flex-row-reverse">
                    <v-btn class="primary" style="min-width: 100px !important" @click="addFilters()"> {{
                        $t("res_ButtonText_AddFilters") }} </v-btn>
                </v-card-actions>
            </v-dialog>
        </div>
    </div>
</template>
<script>
import StructureUserSelector from '@/components/StructureUserSelector.vue';
import Multiselect from 'vue-multiselect';
import constants from '../assets/js/constants.js';
import * as utils from '../assets/js/common.js'
import axios from 'axios';
import DynamicFormRender from '@/components/DynamicFormRender.vue';
import FormBuilderUtil from '@/utils/formBuilderHelper';
import { json } from 'd3';

export default {
    name: 'AdvancedSearchFilters',
    props: {
        filter: { type: Object, default: function (){return {};} },
        applyFiltersOnReset :{type: Boolean ,default:false },
    },
    components: {
        StructureUserSelector, Multiselect, DynamicFormRender
    },
    data() {
        return {
            constants: constants,
            utils: utils,
            selectedItem: null,
            selected: [],
            privacies: [],
            priorities: [],
            from_date_datePicker: false,
            to_date_datePicker: false,
            dynamicFormByStructureIdAndCategoryId: 'dynamicFormByStructureIdAndCategoryId',
            filterByStructureIdAndCategoryId: {} = { id: '', templateName: '', referenceNumber: '', structureId: 0, categoryId: 0, templateId: 0, url: constants.baseApiUrl, isEditable: 1 },
            templateRenderObjects: [],
            currentUserStructureId: 0,
            showDynamicFormsFilterDialog: false,
            dynamicFormFilter_byStructureDictionary: null,
            dynamicFormFilter_byTemplateDictionary: null,
            categories: [],
            statuses: [],
            templates:[],
            purposes:[],
            dynamicFormloaded: false,
            dynamicFormRandomRef: (Math.floor(Math.random() * 100) + 1).toString(),
            local_filter : {
                subject: "",
                referenceNumber: "",
                fromDate: "",
                toDate: "",
                fromStructure: { id: 0, isUser: false, name: '' },
                toStructure: { id: 0, isUser: false, name: '' },
                fromUser: { id: 0, name: '' },
                toUser: { id: 0, name: '' },
                category: { id: 0, text: '' },
                privacyLevel: { id: 0, name: '' },
                priorityLevel: { id: 0, name: '' },
                note: "",
                category: {},
                RejectedByMe: false,
                ArchivedByMe: false,
                SignedByMe: false,
                isDynamicFormsFiltered: false,
                dynamicFormFilter_byStructure: null,
                dynamicFormFilter_byTemplate: null
            }
        }
    },
    created() {

    },
    mounted() 
    {
        this.resetFilters()
        this.privacies = constants.privacies
        this.priorities = constants.priorities
        this.categories = constants.categories
        this.statuses = constants.statuses
        this.purposes=constants.purposes;//lookups.actions

        utils.copyObject(this.filter,this.local_filter)
        this.getUserStructures()
        this.getTemplates()
    },
    watch: {
        filter: {
            handler(newVal, oldVal) {
                if (newVal != {}) {
                    this.local_filter = utils.copyObject(newVal,this.local_filter)
                }
            },
            deep: true
        }
    },
    methods: {
        resetFilters() 
        {
            this.local_filter = {
                subject: "",
                referenceNumber: "",
                fromDate: "",
                toDate: "",
                fromStructure: { id: 0, isUser: false, name: '' },
                toStructure: { id: 0, isUser: false, name: '' },
                fromUser: { id: 0, name: '' },
                toUser: { id: 0, name: '' },
                category: { id: 0, text: '' },
                privacyLevel: { id: 0, name: '' },
                priorityLevel: { id: 0, name: '' },
                status: { id: 0, name: '' },
                purpose: { id: 0, name: '' },
                receivedDate :"",
                content: "",
                tags: "",
                links: "",
                template: { id: 0, name: '' },
                note: "",
                category: {},
                RejectedByMe: false,
                ArchivedByMe: false,
                SignedByMe: false,
                isDynamicFormsFiltered: false,
                dynamicFormFilter_byStructure: null,
                dynamicFormFilter_byTemplate: null
            }

            this.dynamicFormFilter_byStructureDictionary = null
            this.dynamicFormFilter_byTemplateDictionary = null
            this.dynamicFormloaded = false
            if (this.applyFiltersOnReset)
                this.applyFilters();
        },
        getUserStructures() 
        {
            axios.post(constants.baseApiUrl + 'StructureUser/GetCurrentUserStructures', null)
                .then(response => {
                    if (response && response.data.length > 0) {
                        this.currentUserStructureId = response.data[0].structureId;
                    }
                })
                .catch(error => console.log(error))
                .finally(() => this.loading = false);
        },
        getTemplates()
        {
            axios.post(constants.baseApiUrl + 'Template/GetAllTemplates', null)
                .then(response => {
                    if (response && response.data.length > 0) {
                        this.templates = response.data;
                    }
                })
                .catch(error => console.log(error))
                .finally(() => this.loading = false);
        },
        applyFilters() 
        {
            this.local_filter.dynamicFormFilter_byStructure = !utils.CheckIfNullOrEmpty(this.dynamicFormFilter_byStructureDictionary) ? JSON.stringify(this.dynamicFormFilter_byStructureDictionary) : null;
            this.local_filter.dynamicFormFilter_byTemplate = !utils.CheckIfNullOrEmpty(this.dynamicFormFilter_byTemplateDictionary) ? JSON.stringify(this.dynamicFormFilter_byTemplateDictionary) : null;
            this.local_filter.enableAdvancedSearch = true;
            this.$emit('applyFilters', this.local_filter);
        },
        clearFilters() {
            this.resetFilters();
        },
        setStructure(item, type) {
            if (type == 1)
                this.local_filter.fromStructure = item;
            else
                this.local_filter.toStructure = item
        },
        setUser(selectedUserItem, type) {
            if (type == 1) {
                this.local_filter.fromUser = selectedUserItem;
                this.local_filter.fromUser.id = selectedUserItem.id.split('-')[0];
            }
            else {
                this.local_filter.toUser = selectedUserItem;
                this.local_filter.toUser.id = selectedUserItem.id.split('-')[0];
            }
        },
        async openDynamicFormsFilterDialog() {
            this.showDynamicFormsFilterDialog = true;
            if(this.dynamicFormloaded)
                return;
            setTimeout(() => {
                this.filterByStructureIdAndCategoryId.categoryId = -1;
                this.filterByStructureIdAndCategoryId.structureId = this.currentUserStructureId;
                this.$refs.formStructureAndCategory.generateHtmlForForm();
            }, 200);
            await axios.get(constants.baseApiUrl + 'DynamicForms/GetTemplateIdsHaveDynamicForms')
                .then((res) => {
                    if (!utils.CheckIfNullOrEmpty(res) && res.data.length > 0) {

                        for (var index = 0; index < res.data.length; index++) {
                            let object = {
                                dynamicFormByTemplateId: 'dynamicFormByTemplateId_' + index,
                                filterByTemplateId: { id: '', templateName: '', referenceNumber: '', structureId: 0, categoryId: 0, templateId: res.data[index], url: constants.baseApiUrl, isEditable: true },
                            }
                            this.templateRenderObjects.push(object);
                        }
                        //
                        setTimeout(() => {
                            this.generateHtmlForAllTemplateForms();
                        }, 200);
                    }
                })
                .catch((err) => { console.log(err); })
            this.dynamicFormloaded = true
        },
        generateHtmlForAllTemplateForms() {
            for (let index = 0; index < this.templateRenderObjects.length; index++) {
                let dynamicFormRef = this.$refs['dynamicForm_' + index ];
                if (dynamicFormRef[0]) {
                    dynamicFormRef[0].generateHtmlForForm();
                }
            }
        },
        addFilters() {
            this.dynamicFormFilter_byTemplateDictionary = {};
            //structure
            let byStructureAndCategory = new FormBuilderUtil([]);
            byStructureAndCategory.invoke(this.filterByStructureIdAndCategoryId, this.byStructureHandler);

            //template
            for (let index = 0; index < this.templateRenderObjects.length; index++) {
                let byTemplate = new FormBuilderUtil([]);
                let filterByTemplateId = this.templateRenderObjects[index].filterByTemplateId;
                byTemplate.invoke(filterByTemplateId, this.byTemplateHandler);
            }
            //----
            this.local_filter.isDynamicFormsFiltered = true;
            this.showDynamicFormsFilterDialog = false;
        },
        byStructureHandler(event) {
            this.dynamicFormFilter_byStructureDictionary = event.detail.data;
        },
        byTemplateHandler(event) {
            for (const key in event.detail.data) {
                this.dynamicFormFilter_byTemplateDictionary[key] = event.detail.data[key];
            }
        },
        validateDate(dateToRemove) {
            if (this.local_filter.fromDate && this.local_filter.toDate) {
                if (this.local_filter.fromDate > this.local_filter.toDate) {
                    window.showAlert("res_Msgs_FromDateCompare", "warning");
                    if (dateToRemove == 'to') {
                        this.local_filter.toDate = ''
                    } else {
                        this.local_filter.fromDate = ''
                    }
                }
            }
        }
    },
}
</script>

<style scoped>
.red-dot {
    width: 8px;
    height: 8px;
    background-color: red;
    border-radius: 50%;
    position: absolute;
    top: -1px;
    right: -3px;
    z-index: 99
}</style>